import React, { Fragment, useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import { FaSearch } from "react-icons/fa";
import { serviceGetHistorialHitos, verDocumentoHito } from '../../../../../api/api-antecendentes-legales';
import { LoadingComponent } from 'recupero-comunes';


const Historial = ({ codTipoGestion, proceso, loadData, setLoadData, showHistorial, handleClickHistorial, setHandleClickHistorial }) => {
    const data_recepciona = useSelector((state) => state.recepcionaCasoReducer);
    const { llaves } = data_recepciona;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const obtenerColumnas = [
        {
            dataField: 'glosaHito',
            text: 'Hito',
            sort: true,
            headerAlign: 'center',
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: { backgroundColor: '#728bb0', color: 'white', width: '20%', }
        },
        {
            dataField: 'fechaHitoFormat',
            text: 'Fecha Ocurrencia',
            sort: true,
            headerAlign: 'center',
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: { backgroundColor: '#728bb0', color: 'white' }
        },
        {
            dataField: 'fechaAudienciaFormat',
            text: 'Fecha Audiencia',
            sort: true,
            headerAlign: 'center',
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: { backgroundColor: '#728bb0', color: 'white' }
        },
        {
            dataField: 'comentario',
            text: 'Comentario',
            sort: true,
            headerAlign: 'center',
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: {
                width: '20%',
                backgroundColor: '#728bb0',
                color: 'white',
                verticalAlign: 'middle'
            }
        },
        {
            dataField: 'usuario',
            text: 'Usuario',
            sort: true,
            headerAlign: 'center',
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: {
                backgroundColor: '#728bb0',
                color: 'white',
                verticalAlign: 'middle'
            }
        },
        {
            dataField: 'fechaRegistroHitoFormat',
            text: 'Fecha Registro',
            headerAlign: 'center',
            sort: true,
            align: 'center',
            headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
                <div className="table_header_font">
                    {column.text}
                    <br />
                    {sortElement}
                </div>
            ),
            headerStyle: {
                backgroundColor: '#728bb0',
                color: 'white',
                verticalAlign: 'middle'
            }
        },
        {
            dataField: 'opciones',
            text: '',
            isDummyField: true,
            headerStyle: (colum, colIndex) => {
                return {
                    width: '5%',
                    textAlign: 'center',
                    verticalAlign: 'center',
                    backgroundColor: '#728bb0',
                    color: 'white'
                }
            },
            style: { textAlign: 'center', verticalAlign: 'middle' },
            formatter: (cell, row) => {
                return <FaSearch
                    size={20}
                    title={row.folioCarga ? "Ver Documentación del Hito" : "No existe documentación"}
                    style={{ color: 'gray', cursor: row.folioCarga ? 'pointer' : 'not-allowed' }}
                    onClick={() => handleShowPreInforme(row.folioCarga)}
                />
            },
            headerStyle: { backgroundColor: '#728bb0', color: 'white' }
        }
    ]

    useEffect(() => {
        if (handleClickHistorial) {
            getHistorialHitos();
            setHandleClickHistorial(false);
        }
    }, [handleClickHistorial])

    useEffect(() => {
        if (loadData && showHistorial) { getHistorialHitos(); setLoadData(false) }
    }, [loadData])

    useEffect(() => { setData([]); }, [proceso.idInstancia])

    const getHistorialHitos = async () => {
        setLoading(true);
        const query = Buffer.from(JSON.stringify({
            idCaso: llaves.idCaso,
            idImplicado: 0,
            idModoIngreso1: proceso.modoIngresoCompetencia,
            idModoIngreso2: null,
            tipoGestion: codTipoGestion,
            ambitoGestion: null,
            responsableReasignado: false,
            instanciaProceso: proceso.idInstancia
        })).toString('base64');

        const response = await serviceGetHistorialHitos(query);
        setLoading(false);
        setData(response);
    }

    const handleShowPreInforme = async (folio) => {
        if (folio) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({
                idCaso: llaves.idCaso,
                idImplicadoCaso: 0,
                idCompania: llaves.idOrgCaso,
                idfolioCarga: folio
            })).toString('base64')

            const response = await verDocumentoHito(query);
            setLoading(false);

            var link = document.createElement("a");
            link.download = response.filename;
            link.href = "data:" + response.mimetype + ";base64," + response.file;
            link.click();
        }
    }

    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Row className='mt-2 mb-3'>
                <Col>
                    <ToolkitProvider
                        bootstrap4
                        keyField='secuencia'
                        data={data ? data : []}
                        columns={obtenerColumnas}
                        defaultSorted={[{ dataField: 'hito', order: 'asc' }]}
                    >
                        {(props) => (
                            <div>
                                <BootstrapTable
                                    {...props.baseProps}
                                    bordered={false}
                                    headerWrapperClasses='table-secondary'
                                    noDataIndication={
                                        <div className='text-center'>
                                            No hay registros encontrados
                                        </div>
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                </Col>
            </Row>

            <style type='text/css'>
                {`
                    .table_header_font {
                        font-size: 15px;
                    }
                `}
            </style>
        </Fragment>
    )
}

export default Historial